module.exports = __webpack_public_path__ + "static/img/12.f5e108a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20250704/12.png
// module id = n+O/
// module chunks = 0